import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'app-file-uploader-input',
  templateUrl: './file-uploader-input.component.html',
  styleUrl: './file-uploader-input.component.scss'
})
export class FileUploaderInputComponent {

  @Output() uploadComplete: EventEmitter<string> = new EventEmitter();
  @Input() squareSize?: any;
  @Input() directory?: string;

  constructor(private fileService: FileService) {
  }

  async onFileSelected(event: any) {
    let file: File = event.target.files[0];
    if (file) {
      if (this.squareSize) {
        file = await this.fileService.resizeImageToSquare(file, this.squareSize);
      }

      let filePath = `uploads/${file.name}`;

      if (this.directory) {
        filePath = `uploads/${this.directory}/${file.name}`;
      }

      this.fileService.uploadFileAndGetMetadata(filePath, file)
        .subscribe(uploadData => {
          uploadData.percentage.subscribe(progress => {
            // if (!environment.production && environment.debug) {
            //   console.log(`Upload Progress: ${progress}%`);
            // }
            if (progress === 100) {
              uploadData.downloadURL.subscribe(url => {
                if (url) {
                  this.uploadComplete.emit(url);
                }
              });
            }
          });
        });
    }
  }
}
